import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a54df72"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("© 2023 成都百分百文化传播有限公司 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index",
  style: {
    "color": "#fff"
  }
}, "版权所有 蜀ICP备17001887号-1")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系地址：成都市武侯区一环路西一段高升桥路2号1幢1单元1楼Ａ ", -1));
const _hoisted_3 = [_hoisted_1, _hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("footer", null, _hoisted_3);
}